export default __webpack_public_path__ + "static/media/Vered_Cohen-Barzilay_AHV_In_Moms_We_Trust.95222ae6.jpg";